<template>
    <div class="documents-layout" :class="{ 'sidebar-collapsed': !isSidebarVisible }">
        <!-- Sidebar for Filters or Details -->
        <!-- <aside class="filters-sidebar">
            <SearchFilters v-show="activeSubTab === 0" @close-sidebar="isSidebarVisible = false"
                ref="searchFiltersRef" />
            <DocumentDetails v-if="activeSubTab !== 0 && allTabs[activeSubTab] && allTabs[activeSubTab].Document"
                :document="allTabs[activeSubTab].Document" @close-sidebar="isSidebarVisible = false"
                @refresh-document="refreshDocumentData($event)" />
        </aside> -->

        <!-- Main Content Area -->
        <main class="content-area">
            <div class="main-view-container">
                <div v-if="allTabs.length === 0" class="no-docs-message">
                    <h2>Niciun document deschis.</h2>
                </div>
                <div v-else class="subtabs-wrapper">
                    <DxTabPanel :data-source="allTabs" :selected-index.sync="activeSubTab"
                        @option-changed="onSubTabChanged" height="100%" class="subtabs-panel" :scrolling-enabled="true"
                        :show-nav-buttons="true">
                        <template #title="{ data, index }">
                            <div v-if="data && data.title" class="tab-title-container">
                                <span>{{ data.title }}</span>
                                <DxButton v-if="!data.isList" icon="close" text="" styling-mode="text"
                                    @click="closeSubTab(index)" />
                            </div>
                        </template>
                        <template #item="{ data }">
                            <div v-if="data.id === 'linii-tab'" class="list-view-content">
                                <LiniiDocumenteView @open-document="openDocumentDetailTab"
                                    @toggle-filters="toggleSidebar($event)" ref="liniiDocumenteViewRef"
                                    :initial-filters="params" />
                            </div>
                            <div v-else class="line-view-content">
                                <LiniView v-if="data.Document" :document="data.Document"
                                    @toggle-details="isSidebarVisible = !isSidebarVisible"
                                    @refresh-document="refreshDocumentData($event)" />
                            </div>
                        </template>
                    </DxTabPanel>
                </div>
            </div>
        </main>
    </div>
</template>
<script lang="ts">
import LiniiDocumenteView from './LiniiDocumenteView.vue';
import LiniView from './LiniView.vue';
import SearchFilters from './SearchFilters.vue'
import DocumentDetails from './DocumentDetails.vue'
import { DxButton } from 'devextreme-vue/button';
import { DxTabs } from 'devextreme-vue/tabs';
import AppSetting from '@/settings/appSettings';
import DataSource from "devextreme/data/data_source";
import notify from 'devextreme/ui/notify'
import { DxTabPanel } from 'devextreme-vue/tab-panel';
import { defineComponent } from 'vue';

interface OpenDocumentTab {
    id: string,
    documentId: string,
    title: string,
    Document?: any,
    isList?: boolean
}

export default defineComponent({

    name: 'LiniiDocumente',
    components: {
        LiniView,
        LiniiDocumenteView,
        SearchFilters,
        DocumentDetails,
        DxTabs,
        DxTabPanel,
        DxButton
    },
    data() {
        return {
            currentTab: 'Linii',
            params: null as any,
            openDocuments: [] as OpenDocumentTab[],
            activeSubTab: 0,
            uniqueTabCounter: 0,
            isSidebarVisible: true
        }
    },
    computed: {
        allTabs(): OpenDocumentTab[] {
            return [
                { id: 'linii-tab', documentId: '', title: 'Căutare Linii', isList: true },
                ...this.openDocuments
            ];
        }
    },
    async mounted() {
        const storedDocs = localStorage.getItem('openLiniiDocuments')
        const storedActiveSubTab = localStorage.getItem('activeLiniiSubTab')

        if (storedDocs && storedDocs !== 'undefined') {
            const simplifiedTabs = JSON.parse(storedDocs) as Pick<OpenDocumentTab, 'id' | 'documentId' | 'title'>[]

            this.openDocuments = []
            this.loadDocumentsForStoredTabs(simplifiedTabs)
        }
        if (storedActiveSubTab && storedActiveSubTab !== 'undefined') this.activeSubTab = Number(storedActiveSubTab)

        const storedSidebarVisible = localStorage.getItem('isSidebarVisible')
        if (storedSidebarVisible !== null) this.isSidebarVisible = storedSidebarVisible === 'true'

        // Handle direct links in case they are used here too
        const documentIdFromRoute = this.$route.query.id
        if (documentIdFromRoute) {
            try {
                const doc = await this.fetchDocument(documentIdFromRoute as string)
                if (doc) {
                    this.openDocumentDetailTab(doc)
                }
            } catch (e) {
                console.error("Eroare la încărcarea documentului din URL:", e);
            }
        }
    },
    methods: {
        async fetchDocument(documentId: string): Promise<any> {
            const documents = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_DocumenteOdata + 'DOC_CautareDocumente',
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                        };
                    },
                },
            } as any)

            documents.filter(["Id", "=", documentId])
            const result = await documents.load()

            return result[0]
        },
        async loadDocumentsForStoredTabs(simplifiedTabs: Pick<OpenDocumentTab, 'id' | 'documentId' | 'title'>[]) {
            const promises = simplifiedTabs.map(async tab => {
                try {
                    const document = await this.fetchDocument(tab.documentId);

                    return {
                        ...tab,
                        Document: document
                    } as OpenDocumentTab;
                } catch (error) {
                    console.error(`Error loading document ${tab.documentId}:`, error);
                    return null;
                }
            });

            const loadedTabs = (await Promise.all(promises)).filter(tab => tab !== null) as OpenDocumentTab[];
            this.openDocuments = loadedTabs;
        },
        async refreshDocumentData(documentId: string) {
            const fullDoc = await this.fetchDocument(documentId);
            if (fullDoc) {
                const tab = this.openDocuments.find(t => String(t.documentId).toLowerCase() === String(documentId).toLowerCase());
                if (tab) {
                    tab.Document = fullDoc;
                }
            }
        },
        onSubTabChanged(e: any) {
            this.activeSubTab = e.component.option('selectedIndex')
        },
        // onClickChild(value) {
        //     this.$nextTick(() => {
        //         this.params = value;
        //         if (this.activeSubTab === 0 && this.$refs.liniiDocumenteViewRef) {
        //             (this.$refs.liniiDocumenteViewRef as any).loadData(this.params);
        //         }
        //         this.isSidebarVisible = false; // Auto-close sidebar on search
        //     })
        // },
        async openDocumentDetailTab(document) {
            const fullDoc = await this.fetchDocument(document.Id);
            if (!fullDoc) {
                notify("Nu s-au putut încărca detaliile complete ale documentului.", "error", 5000);
                return;
            }

            const getID = (obj: any) => obj ? (obj.Id || obj.ID || null) : null;
            const getString = (val: any) => (val && typeof val === 'object') ? (val.Nume || val.Denumire || val.Simbol || "") : val;

            // Normalize same as Documente.vue
            fullDoc.PartenerId = fullDoc.PartenerId || fullDoc.PartenerID || getID(fullDoc.Partener) || document.PartenerId || document.PartenerID;
            fullDoc.ContractId = fullDoc.ContractId || fullDoc.ContractID || getID(fullDoc.Contract) || document.ContractId || document.ContractID;
            fullDoc.ProiectId = fullDoc.ProiectId || fullDoc.ProiectID || getID(fullDoc.Proiect) || document.ProiectId || document.ProiectID;
            fullDoc.GestiuneIntrareId = fullDoc.GestiuneIntrareId || fullDoc.GestiuneIntrareID || getID(fullDoc.GestiuneIntrare) || document.GestiuneIntrareId || document.GestiuneIntrareID;
            fullDoc.GestiuneIesireId = fullDoc.GestiuneIesireId || fullDoc.GestiuneIesireID || getID(fullDoc.GestiuneIesire) || document.GestiuneIesireId || document.GestiuneIesireID;
            fullDoc.PretValutaId = fullDoc.PretValutaId || fullDoc.PretValutaID || getID(fullDoc.PretValuta) || document.PretValutaId || document.PretValutaID;
            fullDoc.ValutaId = fullDoc.ValutaId || fullDoc.ValutaID || getID(fullDoc.Valuta) || document.ValutaId || document.ValutaID;
            fullDoc.StructIdEditabil = fullDoc.StructIdEditabil || fullDoc.StructIDEditabil || getID(fullDoc.StructuraCompanie) || document.StructIdEditabil || document.StructIDEditabil;
            fullDoc.TipId = fullDoc.TipId || fullDoc.TipID || getID(fullDoc.Tip) || document.TipId || document.TipID;
            fullDoc.CategorieId = fullDoc.CategorieId || fullDoc.CategorieID || getID(fullDoc.Categorie) || document.CategorieId || document.CategorieID;
            fullDoc.AgentId = fullDoc.AgentId || fullDoc.AgentID || getID(fullDoc.Agent) || document.AgentId || document.AgentID;
            fullDoc.ZonaId = fullDoc.ZonaId || fullDoc.ZonaID || getID(fullDoc.Zona) || document.ZonaId || document.ZonaID;
            fullDoc.ComandaId = fullDoc.ComandaId || fullDoc.ComandaID || getID(fullDoc.Comanda) || document.ComandaId || document.ComandaID;

            fullDoc.Partener = getString(fullDoc.Partener) || getString(document.Partener);
            fullDoc.Tip = getString(fullDoc.Tip) || getString(document.Tip);
            fullDoc.Proiect = getString(fullDoc.Proiect) || getString(document.Proiect);
            fullDoc.Categorie = getString(fullDoc.Categorie) || getString(document.Categorie);
            fullDoc.Valuta = getString(fullDoc.Valuta) || getString(document.Valuta);
            fullDoc.Zona = getString(fullDoc.Zona) || getString(document.Zona);
            fullDoc.GestiuneIntrare = getString(fullDoc.GestiuneIntrare);
            fullDoc.GestiuneIesire = getString(fullDoc.GestiuneIesire);

            fullDoc.Tva = fullDoc.Tva !== undefined ? fullDoc.Tva : (fullDoc.TVA !== undefined ? fullDoc.TVA : document.Tva);
            fullDoc.ValoareTva = fullDoc.ValoareTva !== undefined ? fullDoc.ValoareTva : (fullDoc.ValoareTVA !== undefined ? fullDoc.ValoareTVA : document.ValoareTva);
            fullDoc.PretCurs = fullDoc.PretCurs !== undefined ? fullDoc.PretCurs : (fullDoc.Curs !== undefined ? fullDoc.Curs : document.PretCurs);
            fullDoc.Curs = fullDoc.Curs !== undefined ? fullDoc.Curs : (fullDoc.PretCurs !== undefined ? fullDoc.PretCurs : document.Curs);

            if (fullDoc.Contract && typeof fullDoc.Contract === 'object') {
                fullDoc.ContractNumar = fullDoc.Contract.NumarContract || fullDoc.Contract.Numar;
            }
            fullDoc.ContractNumar = fullDoc.ContractNumar || document.ContractNumar || document.NumarContract;

            const existing = this.openDocuments.find(t => String(t.documentId).toLowerCase() === String(document.Id).toLowerCase())
            if (existing) {
                existing.Document = fullDoc;
                const actualIndexInAllTabs = this.allTabs.indexOf(existing);
                if (actualIndexInAllTabs !== -1) {
                    this.activeSubTab = actualIndexInAllTabs;
                }
                return
            }

            const documentID = fullDoc.Id
            this.uniqueTabCounter++

            const newTab: OpenDocumentTab = {
                id: `${fullDoc.Numar} - ${this.uniqueTabCounter}`,
                documentId: documentID,
                title: `${fullDoc.Numar} - ${fullDoc.Tip || 'Document'}`,
                Document: fullDoc
            }

            this.openDocuments.push(newTab);
            this.$nextTick(() => {
                this.activeSubTab = this.allTabs.length - 1;
            });
        },
        closeSubTab(index: number) {
            const openDocsIndex = index - 1;
            if (openDocsIndex < 0) return;

            this.openDocuments.splice(openDocsIndex, 1);

            if (this.activeSubTab >= this.allTabs.length) {
                this.activeSubTab = this.allTabs.length - 1;
            }
        },
        toggleSidebar(section?: string) {
            this.isSidebarVisible = !this.isSidebarVisible;
            if (this.isSidebarVisible && section) {
                this.$nextTick(() => {
                    if (this.$refs.searchFiltersRef) {
                        (this.$refs.searchFiltersRef as any).openSection(section);
                    }
                });
            } else if (this.isSidebarVisible) {
                this.$nextTick(() => {
                    if (this.$refs.searchFiltersRef) {
                        (this.$refs.searchFiltersRef as any).openSection('products');
                    }
                });
            }
        },
    },
    watch: {
        openDocuments: {
            handler(newDocs: OpenDocumentTab[]) {
                const simplifiedDocsToStore = newDocs.map(doc => ({
                    id: doc.id,
                    documentId: doc.documentId,
                    title: doc.title
                }))

                localStorage.setItem('openLiniiDocuments', JSON.stringify(simplifiedDocsToStore))
            }, deep: true
        },
        activeSubTab(newVal) {
            localStorage.setItem('activeLiniiSubTab', newVal)
        },
        isSidebarVisible(newVal) {
            localStorage.setItem('isSidebarVisible', newVal)
        }
    },
})
</script>
<style scoped>
.documents-layout {
    display: flex;
    height: calc(100vh - 64px);
    background-color: #f8f9fa;
    overflow: hidden;
    position: relative;
}

.filters-sidebar {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 400px !important;
    min-width: 400px !important;
    max-width: 400px !important;
    z-index: 1050;
    border-left: 1px solid #e2e8f0;
    background: white;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0;
    box-shadow: -10px 0 30px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-sizing: border-box;
}

.sidebar-collapsed .filters-sidebar {
    transform: translateX(100%);
}

.content-area {
    flex-grow: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
}


.main-view-container {
    padding: 24px;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.subtabs-wrapper {
    flex-grow: 1;
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

.list-view-content {
    padding: 16px;
    height: 100%;
    position: relative;
}

.line-view-content {
    padding: 16px;
    height: 100%;
}

.no-docs-message {
    margin-top: 40px;
    text-align: center;
    color: #64748b;
}

.subtabs-panel .dx-tab {
    flex-shrink: 0;
    min-width: 200px !important;
    max-width: none;
}

.subtabs-panel .dx-tab .tab-title-container {
    display: flex;
    align-items: center;
    width: 100%;
}

.subtabs-panel .dx-tab .tab-title-container span {
    white-space: nowrap;
    flex-grow: 1;
    overflow: hidden;
    text-overflow: ellipsis;
}

.subtabs-panel .dx-tab .tab-title-container .dx-button {
    flex-shrink: 0;
    margin-left: 8px;
}
</style>
